<template>
    <b-table :fields="fields" :items="deviceItems" primary-key="deviceId" striped hover head-variant="light" :busy="loading" show-empty @row-clicked="rowClicked">
        <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-2"/>
                 <strong>Chargement des données…</strong>
            </div>
        </template>
        <template v-slot:empty>
            Aucun matériel n'est actuellement enregistré sur votre compte,
            <router-link to="/device/form">ajoutez-en un</router-link>
            dès maintenant.
        </template>
        <template v-slot:cell(status)="data">
            <status-summary :show-icons="true" :show-text="false" :statuses="data.item.statusSummary"/>
        </template>
        <template v-slot:cell(action)="data">
            <router-link :to="{name: 'deviceEdit', params: {id: data.item.id}}">
                <font-awesome-icon icon="edit" class="mr-2"/>
            </router-link>
            <router-link :to="{name: 'deviceDetails', params: {id: data.item.id}}">
                <font-awesome-icon icon="info-circle"/>
            </router-link>
        </template>

        <template v-slot:row-details="data" v-if="showEvents">
            <events-table :events="data.item.events" v-if="data.item.events.length > 0"/>
        </template>
    </b-table>
</template>

<script>
    import StatusSummary from "../StatusSummary";
    import EventsTable from "../EventsTable";

    export default {
        name: "DevicesTable",
        components: {
            EventsTable,
            StatusSummary
        },
        props: {
            devices: Array,
            loading: Boolean,
            showActions: Boolean,
            showEvents: {
                type: Boolean,
                default: false
            }
        },
        data() {
            let fields = [
                {key: "deviceModel", label: "Modèle"},
                {key: "serial", label: "Numéro de série"},
                {key: "label", label: "Intitulé"},
                {key: "status", label: "État", class: "text-center"}
            ];

            if (this.showActions) {
                fields.push({key: "action", label: "Actions", class: "text-center"});
            }

            return {fields, shownDetails: []};
        },
        methods: {
            rowClicked(item) {
                let showDetails = this.shownDetails[item.deviceId] = !item._showDetails && item.events.length > 0;
                this.$set(item, '_showDetails', showDetails);
            }
        },
        computed: {
            deviceItems() {
                return this.showEvents ? this.devices.map(d => Object.assign({}, d, {_showDetails: this.shownDetails[d.deviceId]})) : this.devices;
            }
        }
    }
</script>

<style scoped>

</style>